import { useEffect, useRef, useState } from "react";
import "./Dropdown.scss";

const DropdownCustom = ({ items = [], onSelect, children }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelect = (item) => {
        setOpen(false);
        onSelect?.(item);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="custom-dropdown" ref={dropdownRef}>
            <div className="dropdown-trigger" onClick={() => setOpen(!open)}>
                {children}
            </div>
            {open && (
                <div className="dropdown-content">
                    {items.map((item) => (
                        <div
                            key={item.value}
                            className="dropdown-item"
                            onClick={() => handleSelect(item)}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DropdownCustom;
